import {LITE_CHAT_INFO_API} from '@src/lib/constants';
import {httpGet} from '@src/lib/utils/request';
import {buildParam} from '@src/lib/utils/tools';

interface GetParams {
    [propName: string]: string | number;
}

export const getChatInfo = (params: GetParams) => {
    const API = `${LITE_CHAT_INFO_API}?${buildParam(params)}`;
    return httpGet({
        url: API,
    }).then(res => res.data);
};
